import { Pipe, PipeTransform, NgZone, ChangeDetectorRef, OnDestroy } from '@angular/core';
@Pipe({
    name: 'calculatedTotal',
    pure: false
})
export class CalculatedTotalPipe implements PipeTransform {
    constructor() { }
    transform(item: any, total: string, key: string) {
        if (total) {
            let sum = 0;
            if (total)
                total.split(',').forEach(key => {
                    sum += +(item[key] ?? 0).toString();
                });
            if (key) item[key] = sum;
            return sum;
        }
        if (key) item[key] = 0;
        return 0;
    }
}
